// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactByClaimsTeamsDto
 */
export interface IContactByClaimsTeamsDto {
    /**
     * 
     * @type {string}
     * @memberof IContactByClaimsTeamsDto
     */
    name_search_value?: string;
    /**
     * 
     * @type {{ [key: string]: Set<number>; }}
     * @memberof IContactByClaimsTeamsDto
     */
    claim_to_claim_team_ids?: { [key: string]: Set<number>; };
}

/**
 * Check if a given object implements the IContactByClaimsTeamsDto interface.
 */
export function instanceOfIContactByClaimsTeamsDto(value: object): value is IContactByClaimsTeamsDto {
    return true;
}

export function IContactByClaimsTeamsDtoFromJSON(json: any): IContactByClaimsTeamsDto {
    return IContactByClaimsTeamsDtoFromJSONTyped(json, false);
}

export function IContactByClaimsTeamsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactByClaimsTeamsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name_search_value': json['name_search_value'] == null ? undefined : json['name_search_value'],
        'claim_to_claim_team_ids': json['claim_to_claim_team_ids'] == null ? undefined : json['claim_to_claim_team_ids'],
    };
}

export function IContactByClaimsTeamsDtoToJSON(json: any): IContactByClaimsTeamsDto {
    return IContactByClaimsTeamsDtoToJSONTyped(json, false);
}

export function IContactByClaimsTeamsDtoToJSONTyped(value?: IContactByClaimsTeamsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name_search_value': value['name_search_value'],
        'claim_to_claim_team_ids': value['claim_to_claim_team_ids'],
    };
}

